export default __webpack_public_path__ + "9aa5a8aaacdf72aecf5d3d5a3ce9f364.png";